<template>
  <div class="filter__item">
    <label class="filter__item__title">
      {{ $t('autocaller_v2.campaign.filter.status.title') }}
    </label>
    <div class="filter__item__body">
      <i-select :value="value" :clearable="true" @input="input">
        <i-option :value="1" :label="$t('autocaller_v2.campaign.filter.status.active')" />
        <i-option :value="0" :label="$t('autocaller_v2.campaign.filter.status.not_active')" />
      </i-select>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: [Number, String],
        default: ''
      }
    },
    methods: {
      input(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
